import 'reflect-metadata';
import { container, inject, injectable } from 'tsyringe';
import { BackgroundController } from './background.controller';
import { LoggerService } from 'app-core/src/services/logger.service';
import { ExternalServicesExposerService } from './services/external-services-exposer.service';
import { BackgroundRegistry } from './bootstrap/background.registry';
import { ExternalServicesRegistry } from './bootstrap/external-services.registry';
import { ConditionsRegistry } from 'app-core/src/bootstrap/conditions-registry';
import { PatchesService } from './services/patches.service';
import { VendorRegistry } from 'app-core/src/bootstrap/vendor.registry';
import { kDIRobloxListener } from 'app-core/src/constants/injectionTokens';
import { SubGameHandlersRegistry } from './sub-game-handlers/sub-game-handlers.registry';

import { Sentry } from '../shared/utils/sentry';
import {
  INotificationAnalyticsService,
  kNameOfNotificationAnalyticsService,
} from 'app-core/src/services/notification-analytics/notification-analytics.service';

// NOTE(twolf): This exposes the dependency injection registries
// eslint-disable-next-line no-unused-vars
const registries = [
  new VendorRegistry(),
  new BackgroundRegistry(),
  new ExternalServicesRegistry(),
  new ConditionsRegistry(),
  new SubGameHandlersRegistry(),
];

// -----------------------------------------------------------------------------
@injectable()
export class BackgroundBootstrap {
  // ---------------------------------------------------------------------------
  public constructor(
    private readonly backgroundController: BackgroundController,
    private readonly exposerService: ExternalServicesExposerService,
    @inject(kNameOfNotificationAnalyticsService)
    private readonly analyticsService: INotificationAnalyticsService,
  ) {
    this.startup();
  }

  // ---------------------------------------------------------------------------
  private async startup() {
    Sentry.initSentry();
    LoggerService.setup('Overwolf Notifications');

    container.resolve(PatchesService);
    container.resolve(kDIRobloxListener);
    this.exposerService.initialize();
    this.backgroundController.run();
  }
}

container.resolve(BackgroundBootstrap);
